module.exports = __webpack_public_path__ + "img/qrwechatmini.39bf494e.jpg";